import React, { useState } from 'react'
import { useAuth, useAnalytics } from 'hooks'
import { Button, TextInput, Modal, ModalNavHeader } from 'elements'
import useReportTemplateCreate from './hooks/useReportTemplateCreate'
import ModalContent from '../../app/ModalContent'

export default function CreateTemplateStep({
  handleTemplateChange,
  configSections,
  onNext,
  onBack,
  onClose,
}) {
  const [submitting, setSubmitting] = useState(false)
  const [templateName, setTemplateName] = useState('')
  const [templateDescription, setTemplateDescription] = useState('')
  const { currentOrg } = useAuth()
  const analytics = useAnalytics()
  const [createReportTemplate] = useReportTemplateCreate()

  const handleCreate = async () => {
    setSubmitting(true)

    const { reportTemplate } = await createReportTemplate({
      reportTemplate: {
        name: templateName,
        description: templateDescription,
        organizationId: currentOrg.rowId,
        config: { sections: configSections },
      },
    })

    handleTemplateChange(reportTemplate)

    analytics.track('Report Template Created', {
      templateId: reportTemplate.rowId,
      organizationId: currentOrg.rowId,
      sectionNames: configSections.map((section) => section.name),
    })

    onNext()
  }

  const canContinue = templateName.length

  return (
    <>
      <ModalNavHeader titleText="Create New Template" onBack={onBack} onClose={onClose} />
      <ModalContent>
        <TextInput
          value={templateName}
          onChange={(event) => setTemplateName(event.target.value)}
          placeholder="Template Name"
          mb="medium"
        />
        <TextInput
          value={templateDescription}
          onChange={(event) => setTemplateDescription(event.target.value)}
          placeholder="Description"
          mb="medium"
        />
      </ModalContent>
      <Modal.Footer display="flex" alignItems="center">
        <Button
          mr="medium"
          kind="secondary"
          onPress={handleCreate}
          disabled={submitting || !canContinue}
        >
          {submitting ? 'Creating...' : 'Create Template'}
        </Button>
        <Button onPress={onClose} mr="xxxlarge">
          Cancel
        </Button>
      </Modal.Footer>
    </>
  )
}
